import { render, staticRenderFns } from "./DewormingThirdPage.vue?vue&type=template&id=62f8b01c&scoped=true&"
import script from "./DewormingThirdPage.vue?vue&type=script&lang=js&"
export * from "./DewormingThirdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f8b01c",
  null
  
)

export default component.exports